import React, { useState, useMemo, useEffect } from 'react'
import { Elements, useStripe, PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'

import reserveApi from '../../utils/axios'
import Card from '../utils/Card'

import { STRIPE_KEYS } from '../../utils/constants'

const Stripe = ({ name, email, onSuccess, product, amount, validation, onButtonAdd }) => {
  const stripe = useStripe()
  const [paymentRequest, setPaymentRequest] = useState(null)
  const [isPaymentLoading, setPaymentLoading] = useState(false)
  const [stripeError, setStripeError] = useState()

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Wandering Labs',
          amount: amount * 100
        },
        requestPayerName: true,
        requestPayerEmail: true
      })

      pr.canMakePayment().then(result => {
        if (result) {
          onButtonAdd()
          setPaymentRequest(pr)

          pr.on('paymentmethod', async ev => {
            setPaymentLoading(true)
            const clientSecretResponse = await reserveApi({
              method: 'post',
              url: '/payments/stripe_intent',
              data: {
                product: product.key,
                amount: amount,
                name,
                email
              }
            })

            const clientSecret = clientSecretResponse.data.client_secret

            const paymentResult = await stripe.confirmCardPayment(
              clientSecret,
              {
                payment_method: ev.paymentMethod.id
              },
              { handleActions: false }
            )
            setPaymentLoading(false)
            if (paymentResult.error) {
              setStripeError(paymentResult.error.message)
              ev.complete('fail')
            } else {
              if (paymentResult.paymentIntent.status === 'succeeded') {
                setStripeError(undefined)
                ev.complete('success')
                onSuccess('stripe', paymentResult)
              } else {
                setStripeError(paymentResult.paymentIntent.status)
                ev.complete('fail')
              }
            }
          })
        }
      })
    }
  }, [stripe, amount, product])

  return (
    <div className="mt-4">
      {stripeError && (
        <Card color="lightOrange" small className="inline-block mt-1">
          <span className="text-lg font-bold">{stripeError}</span>
        </Card>
      )}

      {paymentRequest && <PaymentRequestButtonElement options={{ paymentRequest }} />}
    </div>
  )
}

const StripeWrapper = props => {
  const stripePromise = useMemo(() => {
    return loadStripe(STRIPE_KEYS.live)
  }, [])

  return (
    <Elements stripe={stripePromise}>
      <Stripe {...props} />
    </Elements>
  )
}

export default StripeWrapper
